// extracted by mini-css-extract-plugin
export default {"item":"item___wiJj4","icon":"icon___UvIu5"};